import Vue from 'vue'
import './public-path'
import 'normalize.css/normalize.css'

// import Element from 'element-ui'
import './setup/element'
import { emailSuffix } from '@ibu/jslib'
import ruleValidate from '@/utils/validate/ruleValidate'
// import 'element-ui/lib/theme-chalk/index.css'
import './styles/flex.css' // 鉴权系统代码是从开源库拿的，库中有用到这个样事
// import Logger from '@sf-intl/reporter-sdk'

import '@/styles/index.scss' // 全局 css
import md5 from 'js-md5' //  md5
import { logger } from '@/utils/reporter/index'
import App from './App'
import store from './store'
import router from './router'

import i18n from './lang'
import '@/icons' // icon
import '@/permission' // 权限配置

import '@/utils/moment' // moment
import { switchCurrentDevice } from '@/utils/device' // 适配不同设备
import VerticalToggle from '@/utils/verticalToggle' // 展开收起动画
Vue.component(VerticalToggle.name, VerticalToggle)
// import '@/utils/window'
// 全局注册filters
import * as filters from '@/filters'

Object.keys(filters).forEach(key => { Vue.filter(key, filters[key]) })

// 添加 directives
import * as directives from '@/directives/index'
Object.keys(directives).forEach(k => Vue.directive('sf-' + k, directives[k])) // 添加多个derective，以"sf-"开头

import { qrcodeValid, hideTencentQRCode, captchaMiddleHandler } from '@/utils/TencentQrcodeValid'

import { qrcodeValid as commonQrCodeValid, captchaMiddleHandler as commonCaptchaMiddleHandler, CAPTCHA_JS_URL } from '@/utils/QrcodeValid'

import { SfCaptchaInit, SfCaptchaValid } from '@/utils/SfCaptcha'

import { qrcodeValidate } from '@/utils/QrcodeValid'

import { $track, $setProperties } from '@/utils/reporter/index'

import { isEnableSdk, isEnableSdkTel, isEnableSdkMail } from '@/utils/CommonApisHandler'
import { CODEBUG } from 'sfapm' // 安装哪个依赖，就从哪个依赖引入
import { isOS, isUS } from './utils/constant'
// import VConsole from 'vconsole'

// TencentQRCode.init()

// 满意度地址

Vue.prototype.$qrcodeValidate = qrcodeValidate
Vue.prototype.$track = $track
Vue.prototype.$setProperties = $setProperties
Vue.prototype.$isEnableSdk = isEnableSdk
Vue.prototype.$isEnableSdkTel = isEnableSdkTel
Vue.prototype.$isEnableSdkMail = isEnableSdkMail

Vue.prototype.$commonQrCodeValid = commonQrCodeValid
Vue.prototype.$commonCaptchaMiddleHandler = commonCaptchaMiddleHandler
// Vue.prototype.$logger = logger
Vue.prototype.$qrcodeValid = qrcodeValid
Vue.prototype.$hideTencentQRCode = hideTencentQRCode
Vue.prototype.$captchaMiddleHandler = captchaMiddleHandler
Vue.prototype.$SfCaptchaValid = SfCaptchaValid

Vue.prototype.$emailSuffixMatch = emailSuffix.match // 邮箱常用后缀关联
Vue.prototype.$validateVerifyCodeReg = ruleValidate.validateVerifyCodeReg // 验证码正则校验
Vue.prototype.$validatePasswordAgain = ruleValidate.validatePasswordAgain // 验证码正则校验
Vue.prototype.$validatePasswordReg = ruleValidate.validatePasswordReg // 验证码正则校验

Vue.prototype.$isMicroApp = !!(window.__POWERED_BY_QIANKUN__)
// CAPTCHA_JS_URL()

let errorCpt = 0

async function loadCaptcha() {
  try {
    await CAPTCHA_JS_URL()
  } catch (error) {
    console.log('加载验证码失败', JSON.stringify(error))
  }
  if (!window.ICaptcha && errorCpt < 3) {
    errorCpt++
    loadCaptcha()
  }
}

loadCaptcha()

// if (window._global.ENV !== 'PRD') {
//   // eslint-disable-next-line no-new
//   new VConsole({ theme: 'dark' })
// }

window.iuop = {}
// 使用md5
Vue.prototype.$md5 = md5
// 滑块验证码接口错误码
Vue.prototype.$slideCircusErrorCode = '006001'
// 腾讯滑块验证码错误码（前端没问题，后端腾讯服务挂了）
Vue.prototype.$txSlideCircusErrorCode = '006007'

// 国家化
// Vue.use(Element, {
//   i18n: (key, value) => i18n.t(key, value),
// })

Vue.config.productionTip = false

let instance = null
function render(props = {}) {
  const { container } = props
  instance = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount(container ? container.querySelector('#icas') : '#icas')
}

if (!window.__POWERED_BY_QIANKUN__ && !isUS()) {
  // 省略部分 vue3中app为createApp的应用实例， vue2中为引入的vue
  new CODEBUG({
    ENV: window._global['ENV'] === 'PRD' ? 'PROD' : 'ALPHA',
    APPID: 'e57a0191-5ac9-46da-9d22-c0483b724ea2',
    autoTrack: true,
    filter: (reportData) => {
      if (reportData.error && reportData.error.reason) {
        // // 检测到错误，那么先判断错误的字符串的前几个字符是不是在这里面
        // const whiteErrorFirstKey = ['Ir/']
        // // error 的 前几个字符在这个数据里面也过滤
        // if (whiteErrorFirstKey.some(item => reportData.error.reason.indexOf(item) === 0)) {
        //   return false
        // }
        const errorList = [
          'Request failed with status code 998',
          'Error: timeout of 30000ms',
          'Error: Network Error',
          `Cannot read properties of undefined (reading 'getBoundingClientRect') at a.scrollToAc`,
          'chrome-extension', 'Ir/',
          'Illegal invocation',
          'getBoundingClientRect',
          'Converting circular structure to JSON',
          'eval at injectJsCode',
          '账号信息异常，请重新登录',
          'recommend-index.umd.js',
          `"success":false`,
        ]
        return !errorList.find((it) => reportData.error.reason.indexOf(it) > -1)
      } else {
        return true
      }
    },
    blacklistUrls: ['https://cxbff.sf-express.com/cx/api', 'https://ump.sf-express.com/monitor/init/report', 'todo=UpdaterHtmlJs'],
  }) // web实例
}

if (!window.__POWERED_BY_QIANKUN__) {
  // 独立运行
  switchCurrentDevice()
  console.log('独立运行')
  Vue.prototype.$MainAppOfIuop = true
  SfCaptchaInit()
  render()
}
export async function bootstrap() {
  console.log('[vue] vue app bootstraped')
}
export async function mount(props) {
  console.log('[vue] props from main framework', props)

  props.onGlobalStateChange((state, prev) => {
    i18n.locale = state.lang // 取主应用中的lang值
    const other_token = window.localStorage.getItem('IUOP_token') || window.sessionStorage.getItem('token') // 取主应用中的token值
    console.log('other_token', other_token)
    store.commit('user/SET_TOKEN', other_token) // 存储vuex
    if (isOS()) {
      store.commit('app/SET_SYSTEM_SOURCE', state.system_source || 'ICAS_OS') // 存储vuex
    }
    store.dispatch('site/setLanguage', state.lang)
    Vue.prototype.$MainAppOfIuop = state.isMainApp === 'iuop' // 如果主应用是iuop，那就放开title
  }, true)
  window._parent_store_ = props
  // Vue.prototype.$MainAppOfIuop = window._main_app_ === 'iuop'
  render(props)
}
export async function unmount() {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}

export default instance
